<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="姓名">
        <el-input style='width: 177px;' v-model="queryForm.promoterName"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input style='width: 177px;' v-model="queryForm.promoterMobile"></el-input>
      </el-form-item>
      <el-form-item label="所属用户">
        <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
                labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
        </GridSelectU>
      </el-form-item>
      <el-form-item label="所属推广">
        <GridSelectU
          style="width: 177px"
          title="选择推广人"
          labelName="promoterName"
          labelValue="id"
          :value="queryForm.parentId"
          :limit="1"
          size="small"
          placeholder="请选择推广人"
          @getValue="getSeachValuebrandId"
          :columns="PROMOTER_code"
          :searchs="PROMOTER_search"
          dataListUrl="/mpp/promoter/findList"
          entityBeanName="mppPromoter"
          queryEntityUrl="/mpp/promoter/get"
        >
        </GridSelectU>
      </el-form-item>
        <el-form-item label="审核状态">
            <el-select style='width: 177px;' v-model="queryForm.status" placeholder="请选择" clearable size="small">
              <el-option v-for="item in auditStatus" :key="item.key" :value="item.key" :label="item.value">
              </el-option>
            </el-select>
<!--            <el-input style='width: 177px;' v-model="queryForm.status"></el-input>-->
        </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getMppPromoterList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addMppPromoter">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editMppPromoter(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteMppPromoter(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
<!--          <span title="下载模板" class="icon-box" @click="importTemplate">-->
<!--            <Icon color="#606266">-->
<!--              <ArrowDown />-->
<!--            </Icon>-->
<!--          </span>-->
<!--          <span class="icon-box" title="导入数据" @click="isImport">-->
<!--            <Icon color="#606266">-->
<!--              <ArrowExportUp24Regular />-->
<!--            </Icon>-->
<!--          </span>-->
<!--          <span title="导出数据" class="icon-box" @click="exportMppPromoterList">-->
<!--            <Icon color="#606266">-->
<!--              <ArrowDownload24Regular />-->
<!--            </Icon>-->
<!--          </span>-->
          <span class="icon-box" @click="refreshMppPromoterList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="mppPromoterList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
<!--        <el-table-column :show-overflow-tooltip="true" align="center" prop="promoterName" label="推广人姓名" width="180">-->
<!--        </el-table-column>-->
        <el-table-column align="center" prop="promoterHeader" label="推广人头像" width="180">
          <template slot-scope="scope">
            <div v-if='scope.row.promoterHeader'>
              <el-image @click='updateSrcList(scope.row.promoterHeader)' style="width: 60px; height: 60px"
                :src="scope.row.promoterHeader" :preview-src-list="srcList"> </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="promoterMobile" label="推广人信息" width="180">
            <template slot-scope="scope">
                <div>
                    <div style="text-align: left">姓名：{{ scope.row.promoterName }}</div>
                    <div style="text-align: left">电话：{{ scope.row.promoterMobile }}</div>
                    <div style="text-align: left">商务号：{{ scope.row.promoterBno }}</div>
					<div style="text-align: left">上拓店：{{ scope.row.promoteStoreName }}</div>
<!--                    <div style="text-align: left">推广门店比例：{{ scope.row.promoteStoreRatio }}</div>-->
                </div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户" width="180">
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip='true'
            align='center'
            prop='status'
            label='审核状态'
            width='180'
        >
            <template slot-scope="scope">
                <div>{{ computeAuditStatus(scope.row.status)}}</div>
            </template>
        </el-table-column>
          <el-table-column align="center" prop="idFrontSide" label="身份证正面" width="180">
              <template slot-scope="scope">
                  <div v-if='scope.row.idFrontSide'>
                      <el-image @click='updateSrcList(scope.row.idFrontSide)' style="width: 60px; height: 60px"
                                :src="scope.row.idFrontSide" :preview-src-list="srcList"> </el-image>
                  </div>
                  <div v-else>--</div>
              </template>
          </el-table-column>
          <el-table-column align="center" prop="idBackSide" label="身份证反面" width="180">
              <template slot-scope="scope">
                  <div v-if='scope.row.idBackSide'>
                      <el-image @click='updateSrcList(scope.row.idBackSide)' style="width: 60px; height: 60px"
                                :src="scope.row.idBackSide" :preview-src-list="srcList"> </el-image>
                  </div>
                  <div v-else>--</div>
              </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="applyRemarks" label="申请备注" width="180">
          </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="parent.promoterName" label="上级推广人" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="180">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="300">
          <template slot-scope="scop">
            <div class="operation">
              <div @click='mppPromoter1(scop.row)' v-if='scop.row.status == 1'>
                  <el-button type='primary' size='small'>审核</el-button>
              </div>
              <div @click="allotUser(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">门店列表</span>
              </div> 
              <div @click="checkMppPromoter(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editMppPromoter(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteMppPromoter(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="mppPromoterStates[mppPromoterState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
        <div>
          <el-form :model="mppPromoter" ref="mppPromoterForm" :rules="rules" label-width="120px" :inline="true"
            size="small">
            <el-form-item label="推广人姓名" prop="promoterName">
              <el-input style="display:flex;width: 200px;" size="small" v-model="mppPromoter.promoterName"
                :disabled="mppPromoterState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="推广人电话" prop="promoterMobile">
              <el-input style="display:flex;width: 200px;" size="small" v-model="mppPromoter.promoterMobile"
                :disabled="mppPromoterState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="绑定的账号" prop="userId">
              <GridSelectU style="display:flex;width: 200px;" labelName="userName" :disabled="mppPromoterState == 'check'" title="选择用户"
                labelValue="id" :value="mppPromoter.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
            </el-form-item>
            <el-form-item label="推广店铺收益比例" prop="promoteShopRatio" v-if="mppPromoterState != 'add' && mppPromoterState != 'edit'">
              <el-input style="display:flex;width: 200px;" size="small" v-model="mppPromoter.promoteShopRatio"
                :disabled="mppPromoterState == 'check'"></el-input>
            </el-form-item>
<!--            <el-form-item label="推门店比例" prop="promoteStoreRatio" v-if="mppPromoterState != 'add'">-->
<!--              <el-input style='width: 177px;' size="small" v-model="mppPromoter.promoteStoreRatio"-->
<!--                :disabled="mppPromoterState == 'check'"></el-input>-->
<!--            </el-form-item>-->
              <el-form-item label="推广等级：" prop="gradeId">
                <el-select style="width: 200px;" v-model="mppPromoter.gradeId" placeholder="请选择推广等级" :disabled="mppPromoterState == 'check'">
                  <el-option v-for="(item,key) in Select" :label="item.gradeName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="上级推广人" prop="parentId">
              <GridSelectU
                :disabled="mppPromoterState == 'check'"
                style="display:flex;width: 200px;"
                title="选择推广人"
                labelName="promoterName"
                labelValue="id"
                :value="mppPromoter.parentId"
                :limit="1"
                size="small"
                placeholder="请选择推广人"
                @getValue="getValuebrandId"
                :columns="PROMOTER_code"
                :searchs="PROMOTER_search"
                dataListUrl="/mpp/promoter/findList"
                entityBeanName="mppPromoter"
                queryEntityUrl="/mpp/promoter/get"
              >
              </GridSelectU>
            </el-form-item>
            <el-form-item v-if="mppPromoterState == 'check'" label="创建时间" prop="createTime">
              <el-input style="display:flex;width: 200px;" size="small" v-model="mppPromoter.createTime" :disabled="mppPromoterState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="推广人头像" prop="promoterHeader">
                <div style="display:flex;width: 200px;">
                    <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                        :disabled="mppPromoterState == 'check'" class="avatar-uploader" :show-file-list="false"
                        :http-request="uploadImage">
                        <img v-if="mppPromoter.promoterHeader" :src="mppPromoter.promoterHeader" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppPromoter.promoterHeader)">查看</el-button>
                </div>
            </el-form-item>
              <el-form-item label="身份证正面" prop="idFrontSide">
                  <div style="display:flex;width: 200px;">
                      <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                 :disabled="mppPromoterState == 'check'" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadImage1">
                          <img v-if="mppPromoter.idFrontSide" :src="mppPromoter.idFrontSide" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppPromoter.idFrontSide)">查看</el-button>
                  </div>
              </el-form-item>
              <el-form-item label="身份证反面" prop="idBackSide">
                  <div style="display:flex;width: 200px;">
                      <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                 :disabled="mppPromoterState == 'check'" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadImage2">
                          <img v-if="mppPromoter.idBackSide" :src="mppPromoter.idBackSide" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppPromoter.idBackSide)">查看</el-button>
                  </div>
              </el-form-item>
              <el-form-item label='申请备注' prop='applyRemarks'>
                  <el-input :disabled="mppPromoterState == 'check'" style="display:flex;width: 200px;" type='textarea' v-model='mppPromoter.applyRemarks' :rows="6"></el-input>
              </el-form-item>
              <el-form-item
                  label="签约状态"
                  prop="isSign"
              >
                  <el-select
                      v-model="mppPromoter.isSign"
                      :disabled="mppPromoterState == 'check'"
                      size="small"
                      placeholder="请选择签约状态"
                      clearable
                      style="width: 200px"
                  >
                      <el-option label="未签约" :value="0"> </el-option>
                      <el-option label="已签约" :value="1"> </el-option>
                  </el-select>
              </el-form-item>
			  <el-form-item
			      label="考核小区"
			      prop="isCheck"
			  >
			      <el-select
			          v-model="mppPromoter.isCheck"
			          :disabled="mppPromoterState == 'check'"
			          size="small"
			          placeholder="请选择考核状态"
			          clearable
			          style="width: 200px"
			      >
			          <el-option label="不考核" :value="0"> </el-option>
			          <el-option label="需考核" :value="1"> </el-option>
			      </el-select>
			  </el-form-item>
              <el-form-item
                  label="签名图片"
                  prop="signPic"
              >
                  <div style="display:flex;width: 200px;">
                      <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                 class="avatar-uploader" :show-file-list="false" :disabled="mppPromoterState == 'check'"
                                 :http-request="uploadImage11">
                          <img v-if="mppPromoter.signPic" :src="mppPromoter.signPic" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppPromoter.signPic)">查看</el-button>
                  </div>
              </el-form-item>
              <el-form-item
                  label="合同地址"
                  prop="contractUrl"
              >
                  <div style="display:flex;width: 200px;">
                      <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                 class="avatar-uploader" :show-file-list="false" :disabled="mppPromoterState == 'check'"
                                 :http-request="uploadImage12">
                          <img v-if="mppPromoter.contractUrl" :src="mppPromoter.contractUrl" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(mppPromoter.contractUrl)">查看</el-button>
                  </div>
              </el-form-item>
          </el-form>
            <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                      :src="imageSrc" :preview-src-list="srcList"> </el-image>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="mppPromoterState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <AllotStore ref="allotStore" :id="currentRole"></AllotStore>
    <!--审核功能-->
    <el-dialog title='推广人申请审核' :visible.sync='retreatDialogVisible' width='30%'
                       :before-close='handleCloseRetreat'>
                <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='120px'>
                    <!-- <el-form-item label='申请说明：'>
                        <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                                  :disabled='true'></el-input>
                    </el-form-item> -->
                    <el-form-item label='门店名称：'>
                        <el-input style='width: 100%' v-model='retreatForm.storeName'
                                  :disabled='true'></el-input>
                    </el-form-item>
                    <el-form-item label='是否同意：' prop='resource'>
                        <el-radio-group v-model='retreatForm.resource'>
                            <el-radio label='true'>同意</el-radio>
                            <el-radio label='false'>拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='拒绝原因：' v-if="retreatForm.resource == 'false'" prop='desc'>
                        <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                    </el-form-item>
<!--                    <el-form-item label="推广等级：" prop="gradeId" v-if="retreatForm.resource == 'true'">-->
<!--                      <el-select style="width: 177px;" v-model="retreatForm.gradeId" placeholder="请选择推广等级">-->
<!--                        <el-option v-for="(item,key) in Select" :label="item.gradeName" :value="item.id"></el-option>-->
<!--                      </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item label="推广店铺收益比例：" prop="promoteShopRatio" v-if="retreatForm.resource == 'true' && false">
                        <el-input style='width: 177px' v-model='retreatForm.promoteShopRatio'></el-input>
                    </el-form-item>
<!--                    <el-form-item label="推门店比例：" prop="promoteStoreRatio" v-if="retreatForm.resource == 'true'">-->
<!--                        <el-input style='width: 177px' v-model='retreatForm.promoteStoreRatio'></el-input>-->
<!--                    </el-form-item>-->
                </el-form>
                <span slot='footer' class='dialog-footer'>
              <el-button @click='handleCloseRetreat'>取 消</el-button>
              <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
          </span>
            </el-dialog>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import AllotStore from '@/components/shop/AllotStore.vue';
import { USER, USER_SEARCH, PROMOTER, PROMOTER_SEARCH } from '@/utils/constant';
export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    GridSelectU,
    GridSelectLi,
    AllotStore
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetMppPromoterList();
        this.getMppPromoterList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetMppPromoterList();
        this.getMppPromoterList();
        this.$emit('resetCheckState');
      }
    }
  },
  data() {
    return {
      USER_code: USER,
      USER_search: USER_SEARCH,
      PROMOTER_code: PROMOTER,
      PROMOTER_search: PROMOTER_SEARCH,
      queryForm: {
        id: '', //ID
        promoterName: '', //推广人姓名
        promoterHeader: '', //推广人头像
        promoterMobile: '', //推广人电话
        userId: '', //用户
       status: '',
        gradeId: '', //推广人等级
        parentId: '', //父ID
        parentPath: '', //父路径
        createTime: '', //创建时间
      },
      header: {
          token: localStorage.getItem('token')
      },
      action: UPLOAD_API + UPLOAD_PATH,
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      mppPromoterState: 'add',
      mppPromoterStates: {
        add: '新建推广',
        check: '查看推广',
        edit: '修改推广'
      },

      multipleSelection: [],
      mppPromoterList: [],
      mppPromoter: {
        id: '', //ID
        promoterName: '', //推广人姓名
        promoterHeader: '', //推广人头像
        promoterMobile: '', //推广人电话
        userId: '', //用户
          idFrontSide:'',
          idBackSide:'',
          applyRemarks: '',
        promoteShopRatio:'',
        promoteStoreRatio: '',
        gradeId: '', //推广人等级
        parentId: '', //父ID
        parentPath: '', //父路径
        createTime: '', //创建时间
      },
      btnLoading: false,
      currentRole:"",
      Select:[],
      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        promoterName: [{ required: true, message: '推广人姓名不能为空', trigger: 'blur' }],
        promoterHeader: [{ required: true, message: '推广人头像不能为空', trigger: 'blur' }],
        promoterMobile: [{ required: true, message: '推广人电话不能为空', trigger: 'blur' }],
        userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
        gradeId: [{ required: true, message: '推广人等级不能为空', trigger: 'blur' }],
        promoteShopRatio: [{ required: true, message: '推广店铺收益比例不能为空', trigger: 'blur' }],
        promoteStoreRatio: [{ required: true, message: '推广门店收益比例不能为空', trigger: 'blur' }],
        // parentId: [{ required: true, message: '父ID不能为空', trigger: 'blur' }],
        parentPath: [{ required: true, message: '父路径不能为空', trigger: 'blur' }],
          idFrontSide:[{ required: true, message: '身份证正面不能为空', trigger: 'blur' }],
          idBackSide:[{ required: true, message: '身份证反面不能为空', trigger: 'blur' }],
      },
      auditId:'',
      retreatDialogVisible:false,
      applyRemarks:'',
      retreatRules: {
          resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
          desc: [{ required: true, message: '拒绝原因不能为空', trigger: 'blur' }],
          promoteShopRatio: [{ required: true, message: '推广店铺收益比例不能为空', trigger: 'blur' }],
          promoteStoreRatio: [{ required: true, message: '推广门店收益比例不能为空', trigger: 'blur' }],
      },
      retreatForm: {
          resource: '',
          desc:'',
          promoteShopRatio:'',
          promoteStoreRatio: '',
          storeName:"",
      },
      auditStatus:[],
        imageSrc: '',
        srcList: ['']
    };
  },
  created() {
    this.getMppPromoterList();
    this.getSelect();
    this.getAuditStatus();
  },
  methods: {
    beforeImageUpload(file){
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 50MB!');
      }
      return isLt2M;
    },
      getImage(url){
          this.imageSrc = url;
          this.srcList[0] = url;
          this.$refs.images.showViewer = true;
      },
    // 计算AuditStatus
    computeAuditStatus(type){
            for (let i = 0; i < this.auditStatus.length; i++) {
                if(this.auditStatus[i].key == type){
                    return this.auditStatus[i].value
                }
            }
        },
    // 获取AuditStatusEnum枚举
    getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },
    //
    mppPromoter1(item) {
            console.log('applyRemarks',item)
            this.retreatDialogVisible = true;
            this.auditId = item.id;
            this.applyRemarks = item.remarks;
            this.retreatForm.storeName = item.storeName;
            this.retreatDialogVisible = true;
        },

        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';
            this.retreatForm.gradeId = '';
        },

        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    let status = 1;
                    this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                    
                    // this.retreatDialogVisible = false;
                    get(`/mpp/promoter/auditPromoter`, {
                        id: this.auditId,
                        status: status,
                        refuseReason: this.retreatForm.desc,
                        promoteShopRatio: this.retreatForm.promoteShopRatio,
                        promoteStoreRatio: this.retreatForm.promoteStoreRatio,
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleCloseRetreat();
                            this.getMppPromoterList();
                        }
                    });
                }
            });
        },
    allotUser(role) {
      //console.log(role);
      this.currentRole = role;
      setTimeout(() => {
          this.$refs.allotStore.init();
      }, 200);
    },
      //上传缩略图
      uploadImage11(params) {
          const file = params.file;
          let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
          if (!types.includes(file.type)) {
              this.$message.error('图片类型错误!');
          }
          const formData = new FormData();
          formData.append('file', file);
          upload(UPLOAD_PATH, formData).then((res) => {
              if (res.success) {
                  this.mppPromoter.signPic = res.url;
              }
          });
      },
      uploadImage12(params) {
          const file = params.file;
          let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
          if (!types.includes(file.type)) {
              this.$message.error('图片类型错误!');
          }
          const formData = new FormData();
          formData.append('file', file);
          upload(UPLOAD_PATH, formData).then((res) => {
              if (res.success) {
                  this.mppPromoter.contractUrl = res.url;
              }
          });
      },
    getSelect(){
      get(`/mpp/promotergrade/findAll`).then((res) => {
        this.Select = res.list;
        console.log(this.Select)
      });
    },
    // 大图预览
    updateSrcList(src) {
      this.srcList[0] = src
    },
    // 选择推广人
    getValuebrandId(value) {
      this.mppPromoter.parentId = value;
    },
    getSeachValuebrandId(value){
      this.queryForm.parentId = value
    },
    getValueUser(value) {
      this.mppPromoter.userId = value
    },
    getSeachValueUser(value){
      this.queryForm.userId = value
    },
    //上传缩略图
    uploadImage(params) {
        const file = params.file;
        let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
        if (!types.includes(file.type)) {
            this.$message.error('图片类型错误!');
        }
        const formData = new FormData();
        formData.append('file', file);
        upload(UPLOAD_PATH, formData).then((res) => {
            if (res.success) {
                this.mppPromoter.promoterHeader = res.url;
            }
        });
    },
      //上传缩略图
      uploadImage1(params) {
          const file = params.file;
          let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
          if (!types.includes(file.type)) {
              this.$message.error('图片类型错误!');
          }
          const formData = new FormData();
          formData.append('file', file);
          upload(UPLOAD_PATH, formData).then((res) => {
              if (res.success) {
                  this.mppPromoter.idFrontSide = res.url;
              }
          });
      },
      //上传缩略图
      uploadImage2(params) {
          const file = params.file;
          let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
          if (!types.includes(file.type)) {
              this.$message.error('图片类型错误!');
          }
          const formData = new FormData();
          formData.append('file', file);
          upload(UPLOAD_PATH, formData).then((res) => {
              if (res.success) {
                  this.mppPromoter.idBackSide = res.url;
              }
          });
      },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetMppPromoterList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.mppPromoterList = [];
    },
    resetDialog() {
      this.mppPromoterState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        promoterName: '', //推广人姓名
        promoterHeader: '', //推广人头像
        promoterMobile: '', //推广人电话
        userId: '', //用户
        gradeId: '', //推广人等级
        parentId: '', //父ID
        parentPath: '', //父路径
        createTime: '', //创建时间
      };
      this.getMppPromoterList();
    },
    closeDialog() {
      this.showDialog = false
      this.mppPromoter = {
        id: '', //ID
        promoterName: '', //推广人姓名
        promoterHeader: '', //推广人头像
        promoterMobile: '', //推广人电话
        userId: '', //用户
        gradeId: '', //推广人等级
        parentId: '', //父ID
        parentPath: '', //父路径
        createTime: '', //创建时间
        promoteShopRatio: '',
        promoteStoreRatio: '',
          idFrontSide:'',
          idBackSide:'',
          applyRemarks: '',
      };
    },
    submitForm() {
      if (this.mppPromoterState == 'add') {
        this.$refs.mppPromoterForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/promoter/add`, { ...this.mppPromoter }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetMppPromoterList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.mppPromoterState == 'edit') {
        this.$refs.mppPromoterForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            delete this.mppPromoter.user
            delete this.mppPromoter.grade
            delete this.mppPromoter.parent
            post(`/mpp/promoter/edit`, { ...this.mppPromoter }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetMppPromoterList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addMppPromoter() {
      this.showDialog = true;
      this.mppPromoterState = 'add';
    },
    checkMppPromoter(mppPromoterId) {
      console.log(mppPromoterId);
      this.currentMppPromoterId = mppPromoterId;

      this.getMppPromoterById();
      this.showDialog = true;
      this.mppPromoterState = 'check';
    },
    editMppPromoter(mppPromoterId) {
      console.log('mppPromoter', mppPromoterId);
      if (mppPromoterId) {
        this.currentMppPromoterId = mppPromoterId;
        this.getMppPromoterById();
      } else {
        this.mppPromoter = { ...this.mppPromoter, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.mppPromoterState = 'edit';
    },
    deleteMppPromoter(mppPromoterId) {
      let ids = '';
      if (mppPromoterId) {
        ids = mppPromoterId;
      } else {
        ids = this.multipleSelection.map((mppPromoter) => mppPromoter.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/mpp/promoter/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetMppPromoterList();
              this.getMppPromoterList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshMppPromoterList() {
      this.resetMppPromoterList();
      this.getMppPromoterList();
    },
    getMppPromoterList(query = {}) {
      this.loading = true;
      get(`/mpp/promoter/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.mppPromoterList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getMppPromoterById() {
      get(`/mpp/promoter/get`, { id: this.currentMppPromoterId }).then((res) => {
        if (res.success) {
          this.mppPromoter = { ...this.mppPromoter, ...res.mppPromoter };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportMppPromoterList() {
      //this.btnLoading = true;
      exprotExcel(`/mpp/promoter/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/mpp/promoter/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/mpp/promoter/importData`, formData);
      this.refreshMppPromoterList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getMppPromoterList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getMppPromoterList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>